import React from 'react';

function App() {
  return (
    <div>Welcome</div>
  );
}

export default App;
